import { Icon, IconProps } from '@chakra-ui/react'
import { MdAutorenew } from 'react-icons/md'

export function AutoRenewIcon(props: IconProps) {
  return <Icon as={MdAutorenew} {...props} />
}
